import { render, staticRenderFns } from "./SearchAutocomplete.vue?vue&type=template&id=90438b2a"
import script from "./SearchAutocomplete.vue?vue&type=script&lang=js"
export * from "./SearchAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./SearchAutocomplete.vue?vue&type=style&index=0&id=90438b2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports